var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdgeDevicePoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "33px",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u91C7\u96C6\u70B9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0206098%",
    y1: "-32.9793902%",
    x2: "17.0206098%",
    y2: "119.959176%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48FF3B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C7E9",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-342.000000, -516.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u91C7\\u96C6\\u70B9",
    transform: "translate(342.000000, 516.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 32.561052,
    height: 32.561052
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70056894,1 C4.31537282,1 3.2561052,2.19167607 3.2561052,3.75002171 L3.2561052,27.5835432 C3.2561052,29.1418888 4.31537282,30.3335649 5.70056894,30.3335649 L27.3303851,30.3335649 C28.4349546,30.3335649 29.3303851,29.4381344 29.3303851,28.3335649 L29.3303851,3 C29.3303851,1.8954305 28.4349546,1 27.3303851,1 L5.70056894,1 L5.70056894,1 Z M22.0178867,21.4028201 C20.9732441,21.4028201 20.13753,20.5823008 20.13753,19.5566517 C20.13753,19.0438271 20.3464585,18.6335675 20.6598513,18.3258728 L18.7794946,15.4540552 L18.6750303,15.4540552 L16.0634238,21.1976903 C16.3768166,21.505385 16.5857451,22.0182096 16.5857451,22.4284692 C16.5857451,23.4541184 15.750031,24.2746377 14.7053884,24.2746377 C13.6607457,24.2746377 12.8250316,23.4541184 12.8250316,22.4284692 C12.8250316,22.1207745 12.9294959,21.8130798 13.0339602,21.6079499 L10.0044965,18.2233078 C9.90003229,18.3258728 9.69110376,18.3258728 9.48217524,18.3258728 C8.43753261,18.3258728 7.60181851,17.5053535 7.60181851,16.4797043 C7.60181851,15.4540552 8.43753261,14.6335359 9.48217524,14.6335359 C10.5268179,14.6335359 11.362532,15.4540552 11.362532,16.4797043 C11.362532,16.7873991 11.2580677,17.1976587 11.0491392,17.4027886 L14.0786028,20.7874307 C14.2875313,20.6848657 14.4964598,20.6848657 14.7053884,20.6848657 L14.8098526,20.6848657 L17.4214592,14.9412307 C17.1080664,14.6335359 16.8991379,14.2232763 16.8991379,13.7104517 C16.8991379,12.6848026 17.734852,11.8642833 18.7794946,11.8642833 C19.8241372,11.8642833 20.6598513,12.6848026 20.6598513,13.7104517 C20.6598513,14.2232763 20.3464585,14.7361008 20.0330657,15.0437956 L21.8089582,17.8130482 L22.0178867,17.8130482 C23.0625294,17.8130482 23.8982435,18.6335675 23.8982435,19.6592166 C23.7937792,20.6848657 22.9580651,21.4028201 22.0178867,21.4028201 L22.0178867,21.4028201 Z M24.9846718,7.56035568 L6.51539018,7.56035568 L6.51539018,6.43214165 L24.9846718,6.43214165 L24.9846718,7.56035568 L24.9846718,7.56035568 Z",
    id: "\\u5F62\\u72B6",
    fill: "url(#linearGradient-1)"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeDevicePoint);
export default __webpack_public_path__ + "static/media/edgeDevicePoint.ca6c052a2f75f5cdfcb4b01843fc69ad.svg";
export { ForwardRef as ReactComponent };